import * as coreAxios from "axios";
import { commonActions } from "stores/common/commonActions";
import { loginAction } from "stores/LoginStore/loginAction";
import { config } from "../config";

// Apis of new server
export const axios = coreAxios.default.create({
  baseURL: config.apiUrl,
});

export const axiosInterceptor = (dispatch) => {
  axios.interceptors.request.use((request) => {
    const authToken = localStorage.getItem("token");
    const legacyAuthToken = localStorage.getItem("legacyToken");

    if (authToken) {
      request.headers.Authorization = `Bearer ${authToken}`;
    }

    if (legacyAuthToken) {
      request.headers.Authorization02 = legacyAuthToken;
    }

    return request;
  });

  axios.interceptors.response.use(
    (response) => {
      if (response.data) {
        return response.data;
      }
      return response;
    },
    (error) => {
      console.log("Api Error", { error });
      const { response } = error;
      let toastMessage = "Something went wrong! Please contact the support team";
//change
      if (response && response.status === 401) {
        dispatch(loginAction.logout());
        return Promise.reject(error);
      }

      if (response && response.data && response.data.message) {
        toastMessage = response.data.message;
      }

      dispatch(
        commonActions.setSnackbarAction({
          open: true,
          message: toastMessage,
          severity: "error",
        })
      );

      return Promise.reject(error);
    }
  );
};

// Apis of legacy server
export const axiosLegacyInstance = axios.create({
  baseURL: config.legacyApiUrl,
});

export const axiosLegacyInterceptor = (dispatch) => {
  axiosLegacyInstance.interceptors.request.use((request) => {
    const authToken = localStorage.getItem("token");

    if (authToken) {
      request.headers.Authorization = `Bearer ${authToken}`;
    }

    return request;
  });

  axiosLegacyInstance.interceptors.response.use(
    (response) => {
      if (response.data) {
        return response.data;
      }
      return response;
    },
    (error) => {
      console.log("Api Error", { error });
      return Promise.reject(error);
    }
  );
};
